import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { hasReadRelease, markReadRelease } from '@/utils/releaseIndexedDB';
import { releaseData } from '../config/release.config';

interface AppState {
  alreadyLogOut: boolean;
  setAlreadyLogOut: (value: boolean) => void;
  errorMessage: string;
  setErrorMessage: (value: string) => void;

  hasReadCurrentRelease: boolean;
  hydrateReleaseForUser: (email: string, prop_id: number) => Promise<void>;
  setReadCurrentRelease: (email: string, prop_id: number) => Promise<void>;
  openReleaseModal: boolean;
  setOpenReleaseModal: (value: boolean) => void;

  openAboutModal: boolean;
  setOpenAboutModal: (value: boolean) => void;
}

export const useAppStateStore = create<AppState>()(
  persist(
    (set) => ({
      alreadyLogOut: false,
      setAlreadyLogOut: (value) => set({ alreadyLogOut: value }),
      errorMessage: '',
      setErrorMessage: (value: string) => set({ errorMessage: value }),

      // ====== Release (IndexedDB) ======
      hasReadCurrentRelease: true, // default true → badge shows ONLY after hydration confirms unread

      hydrateReleaseForUser: async (email: string, prop_id: number) => {
        const latestRelease = releaseData['en']?.[0];
        const targetVersion = latestRelease?.version || process.env.REACT_APP_VERSION || '2.2.9';

        const read = await hasReadRelease(email, targetVersion, prop_id);
        console.log(
          `[ReleaseDB] Checking if user ${email} has read version ${targetVersion} from database:`,
          read
        );
        set({ hasReadCurrentRelease: read });
      },

      setReadCurrentRelease: async (email: string, prop_id: number) => {
        const latestRelease = releaseData['en']?.[0];
        const targetVersion = latestRelease?.version || process.env.REACT_APP_VERSION || '2.2.9';

        await markReadRelease(email, targetVersion, prop_id);
        set({ hasReadCurrentRelease: true, openReleaseModal: false });
      },
      openReleaseModal: false,
      setOpenReleaseModal: (value) => set({ openReleaseModal: value }),

      openAboutModal: false,
      setOpenAboutModal: (value) => set({ openAboutModal: value }),
    }),
    {
      name: 'app-state',
      partialize: () => ({}),
    }
  )
);
